import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "new new-flex" }
const _hoisted_2 = { class: "gm-nearby" }
const _hoisted_3 = { class: "near-gm-thumb" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "title-tag" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "price-tag"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" À partir de ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" /mois ")
const _hoisted_11 = {
  key: 1,
  class: "promo-tag"
}
const _hoisted_12 = {
  key: 2,
  class: "promo-tag"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, " Promotion ! ", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "carousel-dots" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", null, "Derniers avis clients", -1)
const _hoisted_18 = { class: "gm-nearby" }
const _hoisted_19 = { class: "near-gm-thumb thumb-avis" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "avis-tag" }
const _hoisted_22 = { class: "avatar" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "note" }
const _hoisted_25 = { class: "notes" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Accueil ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Propreté ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Service ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Prix ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = {
  class: "title-tag",
  style: {"backdrop-filter":"blur(5px)"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { class: "carousel-dots" }
const _hoisted_37 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", null, " Offres promotionnelles - " + _toDisplayString(this.getMonth()), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.home_data.promo_gm, (ngm, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: ngm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                    style: _normalizeStyle('background-image: url('+ ngm.img +')')
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h3", null, [
                        _createElementVNode("b", null, _toDisplayString(ngm.name), 1),
                        _hoisted_6,
                        _createElementVNode("span", null, _toDisplayString(ngm.keyword ? ngm.keyword : "") + " " + _toDisplayString(ngm.city), 1)
                      ])
                    ]),
                    (ngm.price > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", null, [
                            _hoisted_8,
                            _hoisted_9,
                            _createElementVNode("span", null, _toDisplayString(ngm.price) + "€", 1),
                            _hoisted_10
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (ngm.box_promo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", null, _toDisplayString(ngm.box_promo), 1)
                        ]))
                      : (ngm.promo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                        : _createCommentVNode("", true)
                  ], 12, _hoisted_4)
                ])
              ], 512)), [
                [_vShow, this.promo_slide == index]
              ])
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.home_data.promo_gm, (ngm, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              onClick: ($event: any) => {this.promo_slide = i; this.stopPromoInterval()},
              class: _normalizeClass({ active : this.promo_slide == i })
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "circle" })
            ], 10, _hoisted_16))
          }), 128))
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.home_data.avis_gm, (ngm, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: ngm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url )
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h3", null, [
                        _createElementVNode("span", _hoisted_22, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_font_awesome_icon, { icon: "user" })
                          ])
                        ]),
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(ngm.last_avis.name) + " ", 1),
                          _hoisted_23,
                          _createElementVNode("span", _hoisted_24, [
                            _createTextVNode(_toDisplayString(ngm.last_avis.note_text) + " ", 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ngm.last_avis.note, (i) => {
                              return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                icon: "star",
                                class: "star"
                              }))
                            }), 256)),
                            _createTextVNode(" - " + _toDisplayString(this.formatDate( ngm.last_avis.date )), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("p", null, _toDisplayString(ngm.last_avis.comment), 1),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", null, [
                          _hoisted_26,
                          _hoisted_27,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ngm.last_avis.notes.accueil, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star"
                            }))
                          }), 256)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - ngm.last_avis.notes.accueil, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star grey"
                            }))
                          }), 256))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_28,
                          _hoisted_29,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ngm.last_avis.notes.proprete, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star"
                            }))
                          }), 256)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - ngm.last_avis.notes.proprete, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star grey"
                            }))
                          }), 256))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_30,
                          _hoisted_31,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ngm.last_avis.notes.service, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star"
                            }))
                          }), 256)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - ngm.last_avis.notes.service, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star grey"
                            }))
                          }), 256))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_32,
                          _hoisted_33,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ngm.last_avis.notes.prix, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star"
                            }))
                          }), 256)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5 - ngm.last_avis.notes.prix, (i) => {
                            return (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              icon: "star",
                              class: "star grey"
                            }))
                          }), 256))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("h3", null, [
                        _createElementVNode("b", null, _toDisplayString(ngm.name), 1),
                        _hoisted_35,
                        _createElementVNode("span", null, _toDisplayString(ngm.keyword ? ngm.keyword : "") + " " + _toDisplayString(ngm.city), 1)
                      ])
                    ])
                  ], 8, _hoisted_20)
                ])
              ], 512)), [
                [_vShow, this.avis_slide == index]
              ])
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.home_data.avis_gm, (ngm, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              onClick: ($event: any) => {this.avis_slide = i; this.stopAvisInterval()},
              class: _normalizeClass({ active : this.avis_slide == i })
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "circle" })
            ], 10, _hoisted_37))
          }), 128))
        ])
      ])
    ])
  ]))
}